<span class="chip--{{ type }}" #chip>
  <ng-content></ng-content>
</span>
